import React, { useEffect, useState, useContext } from 'react';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import Typography from '@mui/material/Typography';
import BugReport from '@mui/icons-material/BugReport';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

import { DataContext } from 'contexts/DataContext';

import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { get, update } from './api';
import { Info } from '@mui/icons-material';

const SubcategoryWeights = () => {
    const dataContext = useContext(DataContext);
    const { t } = useTranslation();
    const [threats, setThreats] = useState([]);
    //const [categories, setCategories] = useState([{} as any]);
    const [subcategories, setSubcategories] = useState([]);
    const [weights, setWeights] = useState({} as any);
    const [saving, setSaving] = useState(false);
    const [currentEdit, setCurrentEdit] = useState({} as any);

    useEffect(() => {
        dataContext.changeShowLoader(true);
        if(dataContext.loading) return;
        if(!dataContext.currentOrganization) return;
        get(dataContext.currentOrganization).then((response) => {
            setThreats(response.threats);
            //setCategories(response.categories);
            setSubcategories(response.subcategories);
            setWeights(response.weights);
            dataContext.changeShowLoader(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataContext.loading,dataContext.currentOrganization]);
    
    return (
        <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
        title={<><Typography variant='pageTitle'>{t('Subcategory Weights')}</Typography></>} 
        actions={[
            {
                label: saving ? t('Saving...') : t('Save'),
                action: () => {
                    dataContext.changeShowLoader(true);
                    let data = new FormData();
                    Object.keys(weights).map((index:any) => {
                        Object.keys(weights[index]).map((index2:any) => {
                            data.append(`weight[${index}][${index2}]`, weights[index][index2]);
                            return true;
                        });
                        return true;
                    });
                    update(dataContext.currentOrganization, data).then((response) => {
                        setWeights(response.weights);
                        toast.success('Weights saved', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            });
                        
                        setSaving(false);
                        dataContext.changeShowLoader(false);
                    });
                }
            }
        ]}>
        
        <Box sx={{ mt: 0 }}>


        <Paper sx={{marginTop:1, padding:1}}>
        <Box sx={{margin:1}}>
         <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={3}>
                        <Item>         
                            <Typography variant='paperTitle'></Typography>
                        </Item>
                    </Grid>
                    {threats.map((threat: any, index:number) => {
                        return <Grid item xs={1} key={index}>
                            <Item sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <Typography variant='paperTitle'>{threat.id}</Typography>
                                <Tooltip title={threat.name}>
                                    <Info sx={{fontSize:14, marginLeft:1}}/>
                                </Tooltip>
                            </Item>
                        </Grid>
                    })}
                </Grid>
        </Box>        
        </Paper>

        {subcategories.map((subcategory: any, index:number) => {
        return <Paper key={index} sx={{marginTop:'1px', padding:'1px'}}>
        <Box sx={{margin:1}}>
                <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={1}>
                        <Item sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>        
                            <Typography variant='paperTitle'>{subcategory.id}</Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={2}>
                        <Item sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>        
                        <Typography sx={{fontSize:11}}>{subcategory.fncs.substring(0,60)}...</Typography>
                            
                            <Tooltip title= {subcategory.fncs}>
                                <Info sx={{fontSize:14, marginLeft:1}}/>
                            </Tooltip>
                        </Item>
                    </Grid>

                    {threats.map((threat: any, index:number) => {
                        return <Grid item xs={1} key={index}>
                            <Item>
                            {currentEdit===`weight[${subcategory.id}][${threat.id}]` && <FormControl fullWidth>
                                <TextField
                                    name={`weight[${subcategory.id}][${threat.id}]`}
                                    variant="filled"
                                    hiddenLabel
                                    fullWidth     
                                    size='small'                       
                                    onBlur={()=>{setCurrentEdit('')}}
                                    onChange={(e) => {
                                        if(e.target.value) {
                                            setWeights({...weights, [subcategory.id]:{...weights[subcategory.id], [threat.id]:e.target.value}})
                                        }}
                                    }
                                    autoFocus
                                    key={weights[subcategory.id] && weights[subcategory.id][threat.id]!==0 ? weights[subcategory.id][threat.id] : ''}
                                    defaultValue={weights[subcategory.id] && weights[subcategory.id][threat.id]!==0 ? weights[subcategory.id][threat.id] : ''}
                                />
                            </FormControl>}
                            {currentEdit!==`weight[${subcategory.id}][${threat.id}]` && 
                            <div 
                            style={{background:'#F0F0F0', borderRadius:'5px 5px 0px 0px', color:'#474B4D', borderBottom: '2px solid #8b8b8b', padding:'8px 12px', cursor:'pointer', width:'85px', height:'37px', fontSize:14}}
                            onClick={()=>{setCurrentEdit(`weight[${subcategory.id}][${threat.id}]`)}} 
                            >
                            {weights[subcategory.id] && weights[subcategory.id][threat.id] ? weights[subcategory.id][threat.id] : ''}
                            </div>}
                            </Item>
                        </Grid>
                    })}
                </Grid>
            </Box>
        </Paper>
        })}
        </Box>
      </AppLayout>
    )
}

export default SubcategoryWeights;